import type { GiftProductSortType } from './types';

export const GIFT_PRODUCT_SORT_TYPE = {
  LATEST: 'LATEST',
  POPULAR: 'POPULAR',
  REVIEW_COUNT: 'REVIEW_COUNT',
} as const;

export const GIFT_PRODUCT_SORT_TYPE_LABEL = {
  [GIFT_PRODUCT_SORT_TYPE.LATEST]: '최근등록순',
  [GIFT_PRODUCT_SORT_TYPE.POPULAR]: '인기순',
  [GIFT_PRODUCT_SORT_TYPE.REVIEW_COUNT]: '후기 많은순',
} as const;

export const SORT_TYPE_OPTIONS = Object.entries(GIFT_PRODUCT_SORT_TYPE).map(
  ([key, value]) => ({
    label: GIFT_PRODUCT_SORT_TYPE_LABEL[key as GiftProductSortType],
    value,
  }),
);
